// extracted by mini-css-extract-plugin
export default {"avatar":"employer-card-list_avatar__iopGe"};